import { useQuery } from '@tanstack/react-query';
import { getUserOptions } from '../../lib/api/options';

export function useUserOptions(enabled = true) {
  return useQuery({
    queryKey: ['options', 'users'],
    queryFn: getUserOptions,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
